import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import { CarouselProvider } from './context/CarouselContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
const routerBasename = window.location.pathname.startsWith('/preview') ? '/preview' : undefined;

root.render(
  <Router basename={routerBasename}>
    <CarouselProvider>
      <App />
    </CarouselProvider>
  </Router>
);
